<div class="p-panel-title w-12" [ngClass]="{ 'hover-effect': showHower }">
    <div class="flex flex-1 justify-content-between align-items-center">
        <div class="flex align-items-center">
            <episode-header-title [episode]="episode"></episode-header-title>
            <documents-requested-ribbon *ngIf="episode?.id" [episodeId]="episode.id" />
        </div>

        <div class="flex align-items-center">
            <ng-container *ngIf="showActionButtons">
                <episode-header-actions
                    *mSM="xSM"
                    [episode]="episode"
                    [showBanButton]="showBanButton"
                    [episodeOptionsButtonBanItems]="episodeOptionsButtonBanItems"
                    [showPlusButton]="showPlusButton"
                    [episodeOptionsButtonPlusItems]="episodeOptionsButtonPlusItems"
                    [showEllipsisButton]="showEllipsisButton"
                    [showViewButton]="showViewButton"
                    [episodeOptionsButtonEllipsisItems]="episodeOptionsButtonEllipsisItems"
                    (refreshEpisodes)="refreshEpisodes.emit()"
                    (viewEpisode)="viewEpisode.emit($event)"></episode-header-actions>

                <ng-template #xSM>
                    <button
                        *ngIf="expandHeaderSmScreen"
                        doNotPropagateClick
                        pButton
                        pRipple
                        type="button"
                        icon="mi mi-expand-all rotate-90"
                        (click)="showEpisodeHeaderDialog = true"
                        class="p-button-rounded p-button-text"></button>
                </ng-template>
            </ng-container>
        </div>
    </div>
</div>

<p-dialog
    [(visible)]="showEpisodeHeaderDialog"
    [modal]="true"
    [style]="{ width: '100%' }"
    appendTo="body">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            <episode-header-title [episode]="episode"></episode-header-title>
        </div>
    </ng-template>

    <div class="flex align-items-center flex-wrap">
        <div class="pt-2">
            <episode-header-title [episode]="episode"></episode-header-title>
        </div>

        <div class="flex flex-1 justify-content-end align-items-center pt-2">
            <episode-header-actions
                [episode]="episode"
                [showBanButton]="showBanButton"
                [episodeOptionsButtonBanItems]="episodeOptionsButtonBanItems"
                [showPlusButton]="showPlusButton"
                [episodeOptionsButtonPlusItems]="episodeOptionsButtonPlusItems"
                [showEllipsisButton]="showEllipsisButton"
                [showViewButton]="showViewButton"
                [episodeOptionsButtonEllipsisItems]="episodeOptionsButtonEllipsisItems"
                (refreshEpisodes)="refreshEpisodes.emit()"
                (viewEpisode)="viewEpisode.emit($event)"></episode-header-actions>
        </div>
    </div>
</p-dialog>
